__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) { return typeof console !== "undefined" && console.warn && console.warn(msg); };
	var uniqueName = "sd-component-web";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@ant-design/icons", "4.7.0", function() { return function() { return __webpack_require__(33090); }; }, 1);
			register("@ant-design/pro-skeleton", "1.0.9", function() { return function() { return __webpack_require__(71214); }; }, 1);
			register("axios", "0.24.0", function() { return function() { return __webpack_require__(74569); }; }, 1);
			register("mobx-react", "7.5.1", function() { return function() { return __webpack_require__(8907); }; }, 1);
			register("mobx", "6.6.1", function() { return function() { return __webpack_require__(84098); }; }, 1);
			register("react-dom", "17.0.2", function() { return function() { return __webpack_require__(54164); }; }, 1);
			register("react-intl-universal", "2.5.3", function() { return function() { return __webpack_require__(34599); }; }, 1);
			register("react-router-dom", "6.3.0", function() { return function() { return __webpack_require__(115); }; }, 1);
			register("react", "17.0.2", function() { return function() { return __webpack_require__(72791); }; }, 1);
			initExternal(3192);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};